import React from "react";
import {Segment} from "semantic-ui-react";

export default function BorderedSegment(props) {
    const {children, borderColor} = props;
    const colorStyle = {borderLeft: `8px solid ${borderColor}`}
    const transparentStyle = {paddingLeft: 'calc(1rem + 8px)'}
    return <Segment style={borderColor ? colorStyle : transparentStyle}>{children}</Segment>
}
